import React, { Fragment, useEffect, useState } from "react";
import CountUp from "react-countup";
// import axiosConfig from "../../services/axiosConfig";
import { ShoppingBag } from "react-feather";
import { MdOutlineProductionQuantityLimits } from "react-icons/md";
import { FaUsers } from "react-icons/fa";
import setHeader from "../../Functions/setHeader";
import axiosConfig from '../../../services/axiosConfig'
import TickPlacementBars from "../../OrdersChart";
import LoadingComponent from "../../common/LoadingComponent";


const EventCharts = ({ data }) => {

  return (
    <Fragment>
      <div className="col-md-4">
        <div className="card">
          <div className="card-body">
            <div className="chart-widget-dashboard">
              <div className="d-flex">
                <div className="flex-grow-1">
                  <h5 className="mt-0 mb-0 f-w-600">
                    <span>
                      <CountUp className="counter" end={data.users} />
                    </span>
                  </h5>
                  <p>Users</p>
                </div>
                <FaUsers />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-4">
        <div className="card">
          <div className="card-body">
            <div className="chart-widget-dashboard">
              <div className="d-flex">
                <div className="flex-grow-1">
                  <h5 className="mt-0 mb-0 f-w-600">
                    <span>
                      <CountUp className="counter" end={data.orders} />
                    </span>
                  </h5>
                  <p>Orders</p>
                </div>
                <ShoppingBag />
              </div>

            </div>
          </div>
        </div>
      </div>
      <div className="col-md-4">
        <div className="card">
          <div className="card-body">
            <div className="chart-widget-dashboard">
              <div className="d-flex">
                <div className="flex-grow-1">
                  <h5 className="mt-0 mb-0 f-w-600">
                    {/* <DollarSign /> */}
                    <span>
                      <CountUp className="counter" end={data.products} />
                    </span>
                  </h5>
                  <p>Total Products</p>
                </div>
                <MdOutlineProductionQuantityLimits />
              </div>

            </div>
          </div>
        </div>
      </div>
      <div>
        <div className="col-lg-12 card p-3">
          <h6 className="card-title">Orders</h6>
          <div className="row">
            {data?.OrderStatusCounts &&
              Object.entries(data.OrderStatusCounts).map(([status, count]) => (
                <div key={status} className="col-md-3">
                  <div className="card-body bg-light text-dark mb-1 p-2">
                    <div className="chart-widget-dashboard">
                      <div className="d-flex">
                        <div className="flex-grow-1">
                          <h5 className="mt-0 mb-0 f-w-600">
                            <span>
                              <CountUp className="counter" end={Number(count)} />
                            </span>
                          </h5>
                          <div className="mb-0">{status.replace("_", " ")}</div>
                        </div>
                        {/* <ShoppingBag /> */}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>


      </div>
      <div className="">
        <div className="col-lg-12 card">
          <TickPlacementBars />
        </div>
      </div>
    </Fragment>
  );
};

export default EventCharts;
